import styled from "@emotion/styled";
import { Input } from "antd";
import { FC, useEffect, useState } from "react";
import { ImageFill } from "../../common/component/ImageFill";
import { DistributorEntity } from "../../module/distributor/entity/distributor.entity";
import { getDistributorDetail } from "../../module/distributor/service/distributor.service";

const noDataMsg = "请核对经销商名称后再次查询";

export const Distributor: FC = () => {
	const [info, setInfo] = useState<DistributorEntity | undefined>(undefined);
	const [noData, setNoData] = useState<string>(noDataMsg);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	const onSearch = async (company: string) => {
		company = company.replace("有限", "").replace("公司", "");
		if (company.length < 4) {
			setInfo(undefined);
			setNoData(noDataMsg);
			return;
		}
		const { data } = await getDistributorDetail(company);
		if (!data) {
			setInfo(undefined);
			setNoData(noDataMsg);
			return;
		}
		setInfo(data);
		setNoData("");
	};

	return (
		<Container>
			<ImageFill src={"https://optibelt.oss-cn-shanghai.aliyuncs.com/img/vhs-assets-css-60350ea6517946eebce0778e189b73bb.jpg"} width={1600} height={500} areaHeight={296} />
			<div className='content'>
				<div className='page-title'>
					<h1>经销商查询</h1>
				</div>
				<div className='searchArea'>
					<div className='search'>
						<Input.Search onSearch={onSearch} placeholder="请输入正确的经销商公司名称，最少提供4个字" allowClear enterButton />
					</div>
					{info && (
						<div>
							{info.province} - {info.company} - {info.level}
						</div>
					)}
					{noData && <div>{noData}</div>}
				</div>
			</div>
		</Container>
	);
};
const Container = styled.div`
	width: 100%;

	.content {
		margin: 0 auto;
	}

	.searchArea {
		width: 70%;
		margin: 0 auto;
		margin-top: 1rem;

		.search {
			margin-bottom: 1rem;
		}
	}
`;
